var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPending1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3842 5.28552V11.3843L15.4501 13.4172M21.5489 11.3843C21.5489 16.9981 16.998 21.5489 11.3842 21.5489C5.77047 21.5489 1.2196 16.9981 1.2196 11.3843C1.2196 5.77053 5.77047 1.21967 11.3842 1.21967C16.998 1.21967 21.5489 5.77053 21.5489 11.3843Z",
    stroke: "#3B82F6",
    strokeWidth: 2.43932,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending1);
export default __webpack_public_path__ + "static/media/pending1.4312f4338ed1f41f0c9e7a73ec4019c6.svg";
export { ForwardRef as ReactComponent };